<template>
  <v-flex wrap dense style="display: flex; align-items: end">
    <div v-if="showDateSearch" class="form-control" style="width: 20%; margin-right: 6px">
      <date-picker
        :append-to-body="false"
        :clearable="true"
        :editable="false"
        input-class="dateSearch"
        name="DateSearch"
        v-model="search.date"
        valueType="date"
        format="DD/MM/YYYY"
        placeholder="เลือกวันที่"
        confirm
      >
        <template v-slot:footer="{ emit }">
          <div style="text-align: left">
            <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
          </div>
        </template>
      </date-picker>
    </div>
    <div v-if="showDateRangeSearch" class="form-control" style="width: 20%; margin-right: 6px">
      <date-picker
        :append-to-body="false"
        :clearable="true"
        :editable="false"
        input-class="dateSearch"
        name="DateSearch"
        v-model="search.startDate"
        valueType="date"
        format="DD/MM/YYYY"
        placeholder="เลือกวันที่เริ่ม"
        confirm
      >
        <template v-slot:footer="{ emit }">
          <div style="text-align: left">
            <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
          </div>
        </template>
      </date-picker>
    </div>
    <div v-if="showDateRangeSearch" class="form-control" style="width: 20%; margin-right: 6px">
      <date-picker
        :append-to-body="false"
        :clearable="true"
        :editable="false"
        input-class="dateSearch"
        name="DateSearch"
        v-model="search.endDate"
        valueType="date"
        format="DD/MM/YYYY"
        placeholder="เลือกวันที่สิ้นสุด"
        confirm
      >
        <template v-slot:footer="{ emit }">
          <div style="text-align: left">
            <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
          </div>
        </template>
      </date-picker>
    </div>
    <div v-if="showGroupSearch" style="width: 40%; margin-right: 12px">
      <multiselect
        v-model="search.group"
        :options="agentGroup ? agentGroup : []"
        track-by="groupname"
        label="groupname"
        name="group"
        :searchable="true"
        selectLabel
        selectedLabel
        deselect-label
        @input="$emit('clickSearch')"
        :placeholder="'เลือกกลุ่ม'"
      ></multiselect>
    </div>
    <div style="width: 100%; display: flex; align-items: center" class="form-group has-search">
      <span class="fa fa-search form-control-feedback"></span>
      <div style="width: 100%" class="form-control">
        <input
          type="search"
          class="depainput rsu mb-0"
          :placeholder="placeholder"
          name="search"
          v-model="search.nameAll"
          @change="$emit('clickSearch')"
        />
      </div>
    </div>
    <!-- <v-btn
      class="background-gradientYellow none-shadow v-btn-ml"
      @click="$emit('clickSearch')"
      >ค้นหา</v-btn
    > -->
    <Button search label="ค้นหา" @click="$emit('clickSearch')" />

    <Button
      v-if="showAdvancedSearch"
      advancedSearch
      label="Advanced Search"
      @click="$emit('clickAdvancedSearch')"
      icon="fa fa-filter"
      @clearSearch="clearFilter"
    />
    

    <!-- <v-btn
      v-if="showAdvancedSearch"
      class="color-gradientBlue color-white none-shadow v-btn-ml"
      @click="$emit('clickAdvancedSearch')"
    >
      <i class="fa fa-filter" aria-hidden="true"></i>&nbsp;Advanced Search
    </v-btn> -->
    <img
      v-if="isSearch"  
      src="/static/img/clear.png"
      alt
      class="responsive-img mb-1 pointer"
      style="height: 24px; margin-left: -12px; margin-bottom: 20px !important; z-index: 1"
      @click="$emit('clearSearch')"
    />
  </v-flex>
</template>

<script>
import Multiselect from 'vue-multiselect'
// import { mapGetters } from 'vuex'
import Button from '@/components/elements/Button.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  props: {
    isSearch: Boolean,
    showGroupSearch: Boolean,
    showDateSearch: Boolean,
    showDateRangeSearch: Boolean,
    showAdvancedSearch: Boolean,
    showClearAdvancedSearch: Boolean,
    clearAdvancedSearch: Boolean,
    search: {
      type: String,
      nameAll: '',
      group: '',
      date: '',
      startDate: '',
      endDate: '',
    },
    placeholder: String,
    agentGroup: Array,
  },
  computed: {
    // ...mapGetters({
    //   agentGroup: 'getAgentGroup',
    // }),
  },
  components: {
    Multiselect,
    Button,
    DatePicker,
  },
  data() {
    return {
      showGroupSearch: false,
      showDateSearch: false,
      showDateRangeSearch: false,
      showAdvancedSearch: false,
      showClearAdvancedSearch: false,
      clearAdvancedSearch: false,
    }
  },
  // mounted() {
  //   console.log(this.isSearch)
  // },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/InputSearch.vue